import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityHistory } from "../../entity/EntityHistory";

export class DtoHistorysGetRes extends EntityHistory {
  public items: EntityHistory[]  = [];
}
